import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import constants from '../../constant.js';
import { Label } from "flowbite-react";
import axios from "axios";

const ShuttleVehicle = () => {

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [city, setCity] = useState(cities[0]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [vehicleData, setVehicleData] = useState([]);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [vehicleId, setVehicleId] = useState('');
    const [status, setStatus] = useState(1);
    const [brand, setBrand] = useState('');
    const [modelName, setModelName] = useState('');
    const [numOfDoors, setNumOfDoors] = useState('');
    const [numOfSeats, setNumOfSeats] = useState('');
    const [image, setImage] = useState('');
    const [totalrows, setTotalRows] = useState('');
    const [totalColumns, setTotalColumns] = useState('');
    const [vehicleNumber, setVehicleNumber] = useState('');

    const navigate = useNavigate();
    const fetchVehicleData = async() => {
        try {
            const url = serverUrl + '/vehicle/fetch_vehicle_make';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setVehicleData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchVehicleData();
    }, [cityFilter]);

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setBrand('');
        setModelName('');
        setStatus(1);
        setNumOfDoors('');
        setNumOfSeats('');
        setImage('');
        setTotalColumns('');
        setTotalRows('');
        setVehicleId('');
        setVehicleNumber('');
    }

    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
        setVehicleId('');
    }

    const handleOpenEdit = (row) => {
        setOpenEditModal(true);
        setBrand(row.brand);
        setModelName(row.model_name);
        setStatus(row.is_active);
        setNumOfDoors(row.no_of_doors);
        setNumOfSeats(row.no_of_seats);
        setImage(row.image);
        setVehicleId(row.id);
        // setTotalColumns(row.total_columns);
        // setTotalRows(row.total_rows);
        setVehicleNumber(row.vehicle_number);
    }

    const handleSubmit = async() => {
        const token = localStorage.getItem('token');
        if(openAddModal && totalColumns<2){
            setMessage('Total columns cannot be less than 2.');
            showSnackbar(true);
            return;
        }
        if(openAddModal && totalrows<2){
            setMessage('Total rows cannot be less than 2.');
            showSnackbar(true);
            return;
        }
        if(openAddModal && numOfSeats<4){
            setMessage('Seat count cannot be less than 4.');
            showSnackbar(true);
            return;
        }
        if(openAddModal && totalColumns>6){
            setMessage('Total columns cannot be greater than 6.');
            showSnackbar(true);
            return;
        }
        if(openAddModal && totalrows>15){
            setMessage('Total rows cannot be greater than 15.');
            showSnackbar(true);
            return;
        }
        if(numOfSeats>100){
            setMessage('Seat count cannot be greater than 100.');
            showSnackbar(true);
            return;
        }
        if(numOfDoors>6){
            setMessage('Number of doors cannot be more than 6.');
            showSnackbar(true);
            return;
        }
        const payload = {
            brand: brand,
            model_name: modelName,
            no_of_doors: numOfDoors,
            no_of_seats: numOfSeats,
            city_id: cityFilter,
            image: image,
            vehicle_type: 4,
            is_active: status,
            token: token,
            // total_rows: totalrows,
            // total_columns: totalColumns,
            vehicle_number: vehicleNumber
        };

        if(totalColumns) payload.total_columns=totalColumns;
        if(totalrows) payload.total_rows=totalrows;
        if(vehicleId!=''){
            payload.id = vehicleId;
        }

        try {
            const url = operationsUrl + '/shuttle/add_update_shuttle_vehicle_make';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchVehicleData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleFileChange = async (event) => {
        const files = event.target.files;
    
        if (files.length === 0) {
            console.error("No file selected");
            return;
        }
    
        const formData = new FormData();
        formData.append("image", files[0]); // Append the first file, not the entire FileList
    
        // console.log("Uploading file:", files[0]); // Debugging log
    
        const url = operationsUrl + '/upload_image';
    
        try {
            const response = await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
    
            const s3Url = response.data.url;
            setImage(s3Url); // Set the uploaded image URL
        } catch (error) {
            alert("Error uploading the image.");
        }
    };
    
    const openSeatStructurePage = (row) => {
        navigate('/shuttle-seat-structure', { state: { rowData: row} });
    }
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Vehicle</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Vehicle
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vehicle Type</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Brand</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Model Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Vehicle Number</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Number of Seats</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Number of Doors</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Total Rows</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Total Columns</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Image</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {vehicleData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                        vehicleData.map((row) => {

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_type}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.brand}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.model_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_number}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.no_of_seats}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.no_of_doors}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.total_rows}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.total_columns}</Typography></TableCell>
                                    <TableCell align="center">
                                        {row.image!="" && (<Typography sx={{ width: 'auto', minWidth: '100px' }}><img src={row.image.trim()} alt="image"
                                            style={{width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ccc'}}/>
                                        </Typography>)}

                                        {row.image=="" && (
                                            <Typography>--</Typography>
                                        )}
                                    </TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.is_active === 1 ? '#0DBA78' : '#D14545' }}>{row.is_active==1?'Active':'Inactive'}</Typography></TableCell>
                                    <TableCell align="center" sx={{minWidth:'230px'}}>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEdit(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                        <Button onClick={()=>openSeatStructurePage(row)} variant="contained" sx={{textTransform:'none', marginLeft:'2%'}}>Seat structure</Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Vehicle' : 'Add Vehicle'}
                                </Typography>

                                <Grid container spacing={2}>
                                
                                    <Grid item xs={12} sm={6}>
                                        <Label>Brand<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Brand" fullWidth variant="outlined" type="text" 
                                            value={brand}
                                            onChange={(e) => setBrand(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, 
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Model Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Model Name" fullWidth variant="outlined" type="text" 
                                            value={modelName}
                                            onChange={(e) => setModelName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    {openAddModal && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Number of Seats<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Number of Seats" fullWidth variant="outlined" type="number" 
                                                value={numOfSeats}
                                                onChange={(e) => setNumOfSeats(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}

                                    {openAddModal && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Number of Doors<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Number of Doors" fullWidth variant="outlined" type="number" 
                                                value={numOfDoors}
                                                onChange={(e) => setNumOfDoors(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}

                                    {openAddModal && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Total Rows<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Total Rows" fullWidth variant="outlined" type="number" 
                                                value={totalrows}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // if (value >= 0 && value <= 15) {
                                                        setTotalRows(value);
                                                    // }
                                                }}
                                                // onChange={(e) => setTotalRows(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}

                                    {openAddModal && (
                                        <Grid item xs={12} sm={6}>
                                            <Label>Total Columns<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Total Columns" fullWidth variant="outlined" type="number" 
                                                value={totalColumns}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // if (value >= 0 && value <= 6) {
                                                    setTotalColumns(value);
                                                    // }
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid>
                                    )}

                                    <Grid item xs={12} sm={6}>
                                        <Label>Vehicle Number<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Vehicle Number" fullWidth variant="outlined" type="text" 
                                            value={vehicleNumber}
                                            onChange={(e) => setVehicleNumber(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '56px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Status<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={status}
                                            fullWidth
                                            onChange={(e) => setStatus( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            <MenuItem value="">Status</MenuItem>
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="0">Inactive</MenuItem>
                                        </Select>
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6}>
                                        <Label>Image</Label>
                                        <br/>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            // multiple 
                                            // value={image}
                                            onChange={handleFileChange}
                                            style={{ marginBottom: "10px", marginTop:'4%' }}
                                        />
                                        {image!='' && (
                                            <Grid2>
                                                <img src={image} height="50px" width="50px" alt="imagee"/>
                                            </Grid2>
                                        )}
                                    </Grid>

                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {openEditModal ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}


            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    )
}

export default ShuttleVehicle;